// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1__c3af3e24fbf36c400530","cls2":"PostPrompt-cls2___ab5bce2f1b928ecdd4c PostPrompt-cls1__c3af3e24fbf36c400530"};